window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.name === 'AbortError') {
    event.preventDefault()
  }
})

document.addEventListener("turbo:before-render", (event) => {
  const originalRender = event.detail.render
  event.detail.render = async (currentElement, newElement) => {
    try {
      await originalRender(currentElement, newElement)
    } catch (error) {
      if (error instanceof DOMException && error.name === "NotFoundError") {
        const newBody = newElement.cloneNode(true)
        if (document.body) {
          document.body.replaceWith(newBody)
        } else {
          document.documentElement.appendChild(newBody)
        }
      } else {
        throw error
      }
    }
  }
})